import {
  Button,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import { BACKGROUND_COLOR_DARK } from "../../constants";

const FillBureauDetailsModa = ({
  isBureauDetailsModalOpen,
  closeBureauDetailsModal,
  setFormValues,
  formValues,
  handleFormSubmit,
  handleBureauDetailsModalCancel,
}) => {
  return (
    <Modal
      isOpen={isBureauDetailsModalOpen}
      onClose={closeBureauDetailsModal}
      isCentered
      size={"sm"}
    >
      <ModalOverlay />
      <ModalContent borderRadius={"20px"} py={3} px={1}>
        <ModalHeader>Bureau Data Information</ModalHeader>
        <ModalBody>
          <FormControl mt={1} isRequired>
            <FormLabel>PAN Number</FormLabel>
            <InputGroup>
              <Input
                type={"Text"}
                placeholder="Enter PAN Number"
                focusBorderColor={BACKGROUND_COLOR_DARK}
                _hover={{ borderColor: BACKGROUND_COLOR_DARK }}
                fontSize={"1.1rem"}
                borderColor={"#ddd"}
                borderRadius={"10px"}
                size="lg"
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    panNumber: e.target.value,
                  });
                }}
              />
            </InputGroup>
          </FormControl>
        </ModalBody>
        <ModalFooter
          display={"flex"}
          flexDirection={"column"}
          rowGap={4}
          alignItems={"center"}
          mt={2}
        >
          <Button
            width={"100%"}
            colorScheme="teal"
            onClick={() => {
              handleFormSubmit();
            }}
          >
            Submit
          </Button>
          <Button
            width={"100%"}
            onClick={handleBureauDetailsModalCancel}
            variant={"outline"}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FillBureauDetailsModa;
